// extracted by mini-css-extract-plugin
export default {"container":"CheckboxInput_container__sf8YF"};